export default __webpack_public_path__ + "static/media/stage-three.838a81ba.svg";